import axios from 'axios';
import {useFormik } from 'formik';
import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';


export default function Register() {
   const [errorMsg, seterrorMsg] = useState()
   const [isloading , setisloading] = useState()
   const navigate = useNavigate()
     const validationSchema = yup.object({
      name : yup.string().required("Name Field is required").min(3 ,"Name must be more than  3 chracters").max(20,"Name must be less than  20 chracters"),
      email : yup.string().required("Email Field is required").matches(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/i , "Enter Valid Email"),
      password : yup.string().required("password Field is required"),
      rePassword :yup.string().required("repassword Field is required"),
      phone:yup.string().required("Phone Field is required"),
     })
  

    // function validate(values){
    //   const errors ={};
    //   if (values.name == ""){
    //     errors.name="Name Field is required"
    //   }else if(values.name.length<3){
    //     errors.name="Name must be more than  3 chracters "
    //   }else if (values.name.length>20){
    //     errors.name="Name must be less than  20 chracters "
    //   }
    //   if (values.email == ''){
    //     errors.email="Email Field is required"
    //   }else if(!(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/i).test(values.email)){
    //     errors.email="Enter Valid Email "
    //   }
    //   if (values.password == ''){
    //     errors.password="password Field is required"
    //   }
    //   // else if(!(/^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,16})$/i).test(values.password)){
    //   //   errors.password=" password must contain special chracter , number and more than 6 chracters and less than 16  "
    //   // }
    //   if (values.rePassword == ''){
    //     errors.rePassword="rePassword Field is required"
    //   }else if(values.rePassword==values.Password){
    //     errors.rePassword="rePassword must equal password "
    //   }
    //   if (values.phone == ''){
    //     errors.phone="phone Field is required"
    //   }
    //   // console.log(errors)
    //   return errors
    // }
  const {values , handleSubmit , handleChange ,errors , touched , handleBlur , isValid}= useFormik({
      initialValues:{
        name:'',
        email :'',
        password:'',
        rePassword:'',
        phone:''
      },
      onSubmit : async ()=>{
       try {
        setisloading(true)
        console.log(values)
        let response = await axios.post('https://ecommerce.routemisr.com/api/v1/auth/signup',values)
        console.log(response.data.message)
        if(response.data.message=="success"){
           navigate('/login')
        }
       } catch (error) {
        seterrorMsg(error.response.data.message)

       }
       setisloading(false)
      },

      validationSchema
     })

  return <>
    <div className="w-75 m-auto my-5 registernDiv p-xl-5 p-2">
      <h1>Register Now :</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name" className='my-1'>Name:</label>
        <input onChange={handleChange} onBlur={handleBlur} value={values.name} type="text" className='form-control mb-3 authoinputs' id='name' name='name' />
       {errors.name && touched.name &&  <p className='alert alert-danger'>{errors.name}</p>}   

       <label htmlFor="email" className='my-1'>Email:</label>
        <input onChange={handleChange} value={values.email} type="email" className='form-control mb-3 authoinputs' id='email' name='email' />
        {errors.email && touched.email &&  <p className='alert alert-danger'>{errors.email}</p>}       

        <label htmlFor="password" className='my-1'>Password:</label>
        <input onChange={handleChange} onBlur={handleBlur} value={values.password} type="password" className='form-control mb-3 authoinputs' id='password' name='password' />
        {errors.password && touched.password &&  <p className='alert alert-danger'>{errors.password}</p>}       

        <label htmlFor="rePassword" className='my-1'>RePassword:</label>
        <input onChange={handleChange} onBlur={handleBlur} value ={values.rePassword}type="password" className='form-control mb-3 authoinputs' id='rePassword' name='rePassword' />
        {errors.rePassword && touched.rePassword &&  <p className='alert alert-danger'>{errors.rePassword}</p>}       

        <label htmlFor="phone" className='my-1'>phone:</label>
        <input onChange={handleChange} onBlur={handleBlur} value={values.phone}type="tel" className='form-control mb-3 authoinputs' id='phone' name='phone' />
        {errors.phone && touched.phone &&  <p className='alert alert-danger'>{errors.phone}</p>}       

       {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
       {         isloading ? <button disabled type='button' className='btn bg-main px-3 text-white ms-auto d-block px-3'> <i className='fas fa-spin fa-spinner px-4'></i> </button>
                  :
                  <button type='submit' disabled ={isloading} className='btn bg-main px-3 text-white ms-auto d-block'>Register</button>
                   }

      </form>
    </div>
  </>
}
